import { createFlagsScheme, schema } from '@funtech-int/yango-shared';

export const featureFlagsScheme = createFlagsScheme({
    isMultiOfferEnabled: schema.boolean.optional(false),
    isNewPlayerEnabled: schema.boolean.optional(false),
    shouldShowCounterOffer: schema.boolean.optional(false),
    isPlusInfoblockEnabled: schema.boolean.optional(false),
    isNewLoginwallEnabled: schema.boolean.optional(false),
    isWideMultiOfferDesktopEnabled: schema.boolean.optional(false),
    isYearAnnualOfferEnabled: schema.boolean.optional(false),
    isNewYearAnnualOfferEnabled: schema.boolean.optional(false),
    isPlusPaywallEnabled: schema.boolean.optional(false),
    isMultiOfferCarouselEnabled: schema.boolean.optional(false),
    isPaywallCarouselEnabled: schema.boolean.optional(false),
});
